export default [
	'supplierBottleChoice',
	'supplierAppleChoice',
	'machines',
	'machineCost',
	'machinesTotalCost'
]
